import React, {Component} from 'react';
import _ from 'lodash';
import { Segment, Accordion, Menu, Form, Icon } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { storeAutoLoanDetails, storeAutoLoanFilterValue, storeCategoryAutoLoanCount } from '../../redux/actions';
import {applyFilterCalculation} from './applyFilter';
import {getConst} from '../../core/consts';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import accounting from 'accounting';
import $ from 'jquery';
import {getStaticText} from '../../core/lang';

// import Tooltip from 'rc-tooltip';

// const Handle = Slider.Handle;

// const handle = (props) => {
//   const { value, dragging, index, ...restProps } = props;
//   return (
//     <Tooltip
//       prefixCls="rc-slider-tooltip"
//       overlay={(value === 50000) ? "50,000+" : accounting.formatMoney(value,"",0)}
//       visible={true}
//       placement="top"
//       key={index}
//       align={{
//         offset: [0, -5],
//       }}
//     >
//       <Handle value={value} {...restProps} />
//     </Tooltip>
//   );
// };

export class Filter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeIndex: {},
      selectedBanks: [],
      selectedCarType: '',
      selectedCardType: '',
      selectedFeatures: [],
      salary: this.props.filterValue ? this.props.filterValue.salary : 5000,
    }
  }

  sliderChange = (value) => {
    this.setState({salary: value});
  }

  handleMonthlySalaryChange = (value) => {
    this.setState({
      salary: value,
      selectedBanks: this.props.filterValue.selectedBanks,
      selectedCardType: this.props.filterValue.selectedCardType,
      selectedFeatures: this.props.filterValue.selectedFeatures,
      selectedCarType: this.props.filterValue.selectedCarType,
    }, () => this.applyFilter())
  }

  handleFilterChange = (e, handleProps) => {
    const {carLoanTypeList} = getConst(this.props.activeLanguage);
    const {name, value, checked } = handleProps;
    let selectedBanks = this.props.filterValue.selectedBanks;
    let selectedCardType = this.props.filterValue.selectedCardType;
    let selectedFeatures = this.props.filterValue.selectedFeatures;
    let selectedCarType = this.props.filterValue.selectedCarType;
    switch(name) {
      case 'bank':
        if (checked) {
          selectedBanks = _.uniq(_.concat(selectedBanks, value));
          if (value === 'all') {
            selectedBanks = []
          }
        } else {
          selectedBanks = _.remove(selectedBanks, (n) => {
            return n !== value;
          });
        }
        break;
      case 'carType':
        if (checked) {
          selectedCarType = value
        }
        break;
      case 'type':
        selectedCardType = value;
        carLoanTypeList.map((row,idx) => 
        (
        selectedCardType === row.type?
        this.props.history.push(row.path):''
        ));
        if(selectedCardType === ''){
          this.setState({selectedCardType:''},()=>{
            this.props.history.push('/car-loans')
          })
        }
        break;
      case 'feature':
        if (checked) {
          selectedFeatures = _.uniq(_.concat(selectedFeatures, value));
        } else {
          selectedFeatures = _.remove(selectedFeatures, (n) => {
            return n !== value;
          });
        }
      break;
      default:
    }
    this.setState({
      selectedBanks,
      selectedCarType,
      selectedCardType,
      selectedFeatures,
      salary: this.props.filterValue.salary,
    },() =>{
      this.applyFilter();
    });

  }

  applyFilter = () => {
    const selectedBanks = this.state.selectedBanks ,selectedCardType= this.state.selectedCardType, selectedFeatures = this.state.selectedFeatures;
    const salary = this.state.salary, selectedCarType = this.state.selectedCarType;
    const allAutoLoanDetails = this.props.allAutoLoanDetails;

    const {filteredCardArrayFinal, typeCountObj, autoLoanFeatureCountObj, carTypesCountObj, autoLoanBankCountObj} = applyFilterCalculation(selectedBanks, selectedCardType,
      selectedFeatures, salary, selectedCarType, allAutoLoanDetails);
    // if (filteredCardArrayFinal.length < 5) {
    //   $('html,body').animate({
    //     scrollTop: 0
    //   }, 300)
    // }

    this.props.storeCategoryAutoLoanCount({typeCountObj, autoLoanFeatureCountObj, carTypesCountObj, autoLoanBankCountObj});

    this.props.storeAutoLoanDetails(filteredCardArrayFinal);
    this.props.storeAutoLoanFilterValue({selectedBanks, selectedCardType, selectedFeatures, salary, selectedCarType});
    this.props.sortAfterFilter();
  }

  componentWillMount() {
  }

  applyFilterWithProps = () => {
    $('html,body').animate({
      scrollTop: 0
    }, 300);
    let selectedCardType= this.state.selectedCardType;
    const selectedBanks = this.props.filterValue.selectedBanks ,selectedFeatures = this.props.filterValue.selectedFeatures;
    const salary = this.props.filterValue.salary, selectedCarType = this.props.filterValue.selectedCarType;
    const allAutoLoanDetails = this.props.allAutoLoanDetails;

    const {filteredCardArrayFinal, typeCountObj, autoLoanFeatureCountObj, carTypesCountObj, autoLoanBankCountObj} = applyFilterCalculation(selectedBanks, selectedCardType,
      selectedFeatures, salary, selectedCarType, allAutoLoanDetails);

    this.props.storeCategoryAutoLoanCount({typeCountObj, autoLoanFeatureCountObj, carTypesCountObj, autoLoanBankCountObj});

    this.props.storeAutoLoanDetails(filteredCardArrayFinal);
    this.props.storeAutoLoanFilterValue({selectedBanks, selectedCardType, selectedFeatures, salary, selectedCarType});
    this.props.sortAfterFilter();
  }

  applySearchWithProps = () => {
    $('html,body').animate({
      scrollTop: 0
    }, 300);
    let selectedCardType= this.state.selectedCardType;
    const selectedBanks = this.props.filterValue.selectedBanks ,selectedFeatures = this.props.filterValue.selectedFeatures;
    const salary = this.props.filterValue.salary, selectedCarType = this.props.filterValue.selectedCarType;
    const allAutoLoanDetails = this.props.allAutoLoanDetails;

    const {filteredCardArrayFinal, typeCountObj, autoLoanFeatureCountObj, carTypesCountObj, autoLoanBankCountObj} = applyFilterCalculation(selectedBanks, selectedCardType,
      selectedFeatures, salary, selectedCarType, allAutoLoanDetails);

    this.props.storeCategoryAutoLoanCount({typeCountObj, autoLoanFeatureCountObj, carTypesCountObj, autoLoanBankCountObj});
    if(selectedCardType === "all" || selectedCardType === ""){
      selectedCardType = "Search results"
    }
    this.props.storeAutoLoanDetails(filteredCardArrayFinal);
    this.props.storeAutoLoanFilterValue({selectedBanks, selectedCardType, selectedFeatures, salary, selectedCarType});
    this.props.sortAfterFilter();
  }

  componentDidMount() {
    const {carLoanTypeList} = getConst(this.props.activeLanguage);
    if (_.has(this.props.location, 'query') && _.has(this.props.location.query, 'cardType')) {
      this.setState({selectedCardType: this.props.location.query.cardType}, () => this.applyFilterWithProps())
    }else if(this.props.location.pathname !== '/car-loans'){
      carLoanTypeList.forEach((item)=>{
        if(this.props.location.pathname ===  item.path){
          this.setState({selectedCardType: item.type}, () => this.applyFilterWithProps())
        }
      })
    }
    if (_.has(this.props.location, 'query') && _.has(this.props.location.query, 'carType')) {
      this.setState({selectedCarType: [this.props.location.query.carType]}, () => this.applyFilter())
    }
    $('.js-trigger-click').on('click', function() {
      $(this).parent().find('.checkbox input').trigger('click');
    });
  }

  componentWillReceiveProps(nextProps) {
    const {carLoanTypeList} = getConst(this.props.activeLanguage);
    if ((nextProps.gotAutoLoanDataFromApi && !_.isEqual(this.props.gotAutoLoanDataFromApi, nextProps.gotAutoLoanDataFromApi)) || !_.isEqual(this.props.location, nextProps.location)) {
      if (_.has(nextProps.location, 'query') && _.has(nextProps.location.query, 'cardType')) {
        this.setState({selectedCardType: nextProps.location.query.cardType}, () => this.applyFilterWithProps())
      }
      else if(this.props.location.pathname !== '/car-loans'){
        carLoanTypeList.forEach((item)=>{
          if(this.props.location.pathname ===  item.path){
            this.setState({selectedCardType: item.type}, () => this.applyFilterWithProps())
          }
        })
      }
      if (_.has(nextProps.location, 'query') && _.has(nextProps.location.query, 'carType')) {
        this.setState({selectedCarType: [nextProps.location.query.carType]}, () => this.applyFilter())
      }
      if(nextProps.location.query !== this.props.location.query){
        this.applySearchWithProps();
      }
    }
     if(nextProps.filterValue !== this.props.filterValue){
      this.setState({
        salary : nextProps.filterValue.salary
      });
     }
  }

  handleSideMenuClick = (e, titleProps) => {
    const { index } = titleProps
    const activeIndex = _.assign(this.state.activeIndex, {[index]: !this.state.activeIndex[index]})
    this.setState({ activeIndex})
    console.log(activeIndex);
  }

  render() {
    console.log("countobj:", this.props.autoLoanBankCountObj);
    const {carType, autoLoanTypeList, autoLoanFeatureList, bankList} = getConst(this.props.activeLanguage);
    const lang = getStaticText(this.props.activeLanguage);
    // let stepValue;
    // if(this.state.salary < 20000){
    //   stepValue = 500;
    // }else if (this.state.salary >= 20000) {
    //   stepValue = 1000;
    // }
    return (
      <Segment.Group className='ui basic segment sw-content-left'>
        <Segment className='ui basic segment'>
          <Accordion as={Menu} vertical className='ui basic segment'>
            <Menu.Item>
              <Accordion.Title
                active={!this.state.activeIndex[0]}
                index={0}
                onClick={this.handleSideMenuClick}>
                {lang.minimum_salary}
                <Icon name='caret up' className='blue' />
                </Accordion.Title>
              <Accordion.Content active={!this.state.activeIndex[0]} content={(
                <div className='filter-accordion'>
                <div className='has-arrow-down text-center margin-top-5 margin-btm-5'>
                  <span>
                    {
                      this.state.salary === 50000 ?
                      `${lang.aed} ${accounting.formatMoney(this.state.salary, '', 0)+"+"}`
                      :
                      `${lang.aed} ${accounting.formatMoney(this.state.salary, '', 0)}`
                    }
                  </span>
                </div>
                  <Slider
                    // step={stepValue}
                    step={500}
                    value={this.state.salary}
                    min={5000}
                    max={50000}
                    onChange={this.sliderChange}
                    onAfterChange={this.handleMonthlySalaryChange}
                  />
                  <span className='placeholder'>5,000</span>
                  <span className='placeholder right'>50,000+</span>
                </div>
              )} />
            </Menu.Item>

            <Menu.Item>
              <Accordion.Title
                active={!this.state.activeIndex[1]}
                index={1}
                onClick={this.handleSideMenuClick}>
                {lang.car_type}
                <Icon name='caret up' className='blue' />
              </Accordion.Title>
              <Accordion.Content active={!this.state.activeIndex[1]} content={(
                <Form>
                  <Form.Group grouped>

                    {
                      !_.has(this.props, 'carTypesCountObj')?<br/>:
                      carType.map((row, idx) => (
                        <div className='position-change position-radio' key={idx} >
                          <Form.Radio
                          label=''
                          name='carType'
                          value={row.value}
                          checked={this.props.filterValue.selectedCarType === row.value}
                          onChange={this.handleFilterChange}
                          className='display-inline-block'
                          disabled={_.has(this.props.carTypesCountObj, row.value)?!this.props.carTypesCountObj[row.value]>0:true}
                          />
                          <span className='width-same-pos'>
                          <span className={this.props.filterValue.selectedCarType === row.value?"js-trigger-click  checked":"js-trigger-click  unchecked"}> {row.text}&nbsp;</span>
                            {_.has(this.props.carTypesCountObj, row.value) && this.props.carTypesCountObj[row.value]>0?
                              <span className='color-gray'>({this.props.carTypesCountObj[row.value]})</span>:
                              <span className='disabled field display-inline-block color-gray'>(0)</span>
                            }
                          </span>
                        </div>
                      ))
                    }
                  </Form.Group>
                </Form>
              )} />
            </Menu.Item>

            <Menu.Item>
              <Accordion.Title
                active={!this.state.activeIndex[2]}
                index={2}
                onClick={this.handleSideMenuClick}>
                {lang.auto_loan_type}
                <Icon name='caret up' className='blue'/>
              </Accordion.Title>
              <Accordion.Content active={!this.state.activeIndex[2]} content={(
                <Form>
                  <Form.Group grouped>
                  <span className='position-change position-radio' >
                    <Form.Radio
                      label=''
                      name='type'
                      value=''
                      className='display-inline-block'
                      checked={this.state.selectedCardType === '' || this.props.filterValue.selectedCardType===''}
                      onChange={this.handleFilterChange}
                    />
                    <span className="width-same-pos">
                    <span className={this.state.selectedCardType === '' || this.props.filterValue.selectedCardType===''?"js-trigger-click  checked":"js-trigger-click  unchecked"}> {lang.all}</span></span>
                    </span>
                    {
                      !_.has(this.props, 'typeCountObj')?<br/>:
                      autoLoanTypeList.map((row, idx) => (
                        <div className='position-change position-radio' key={idx} >
                          <Form.Radio
                          label=''
                          name='type'
                          value={row}
                          checked={this.props.filterValue.selectedCardType === row}
                          onChange={this.handleFilterChange}
                          className='display-inline-block'
                          disabled={_.has(this.props.typeCountObj, row)?!this.props.typeCountObj[row]>0:true}
                          />
                          <span className='width-same-pos'>
                            <span className={this.props.filterValue.selectedCardType === row?"js-trigger-click  checked":"js-trigger-click  unchecked"}> {row} </span>
                            {_.has(this.props.typeCountObj, row) && this.props.typeCountObj[row]>0?
                              <span className='color-gray'>({this.props.typeCountObj[row]})</span>:
                              <span className='disabled field display-inline-block color-gray'>(0)</span>
                            }
                          </span>
                        </div>
                      ))
                    }
                  </Form.Group>
                </Form>
              )} />
            </Menu.Item>

            <Menu.Item>
              <Accordion.Title
                active={!this.state.activeIndex[3]}
                index={3}
                onClick={this.handleSideMenuClick}>
                {lang.features_and_benefits}
                <Icon name='caret up' className='blue'/>
              </Accordion.Title>
              <Accordion.Content active={!this.state.activeIndex[3]} content={(
                <Form>
                  <Form.Group grouped>
                    {
                      !_.has(this.props, 'autoLoanFeatureCountObj')?<br/>:
                      autoLoanFeatureList.map((row, idx) => (
                        <div className='position-change' key={idx}>
                          <Form.Checkbox
                            name='feature'
                            value={row}
                            onChange={this.handleFilterChange}
                            checked={_.indexOf(this.props.filterValue.selectedFeatures, row) >= 0}
                            className='display-inline-block'
                            disabled={_.has(this.props.autoLoanFeatureCountObj, row)?!this.props.autoLoanFeatureCountObj[row]>0:true}
                          />
                          <span className='width-same-pos'>
                            <span className={_.indexOf(this.props.filterValue.selectedFeatures, row) >= 0?"js-trigger-click  checked":"js-trigger-click  unchecked"}> {row} </span>
                            {_.has(this.props.autoLoanFeatureCountObj, row) && this.props.autoLoanFeatureCountObj[row]>0?
                              <span className='color-gray'>({this.props.autoLoanFeatureCountObj[row]})</span>:
                              <span className='disabled field display-inline-block color-gray'>(0)</span>
                            }
                          </span>
                        </div>
                      ))
                    }
                  </Form.Group>
                </Form>
              )} />
            </Menu.Item>

            <Menu.Item>
              <Accordion.Title
                active={!this.state.activeIndex[4]}
                index={4}
                onClick={this.handleSideMenuClick}>
                {lang.banks}
                <Icon name='caret up' className='blue'/>
              </Accordion.Title>
              <Accordion.Content active={!this.state.activeIndex[4]} content={(
                <Form>
                  {!_.has(this.props, 'autoLoanBankCountObj')?'':<Form.Group grouped>
                    <div className="position-change">
                    <Form.Checkbox
                      label=''
                      name='bank'
                      value={'all'}
                      onChange={this.handleFilterChange}
                      checked={_.isEmpty(this.props.filterValue.selectedBanks)}
                      className='display-inline-block'
                    />
                    
                    <span className='width-same-pos'>
                    <span className={_.isEmpty(this.props.filterValue.selectedBanks)?"js-trigger-click  checked":"js-trigger-click  unchecked"}> {lang.all}</span>
                    </span>
                    </div>
                    {
                      bankList.map((row, idx) => (
                        <div key={idx} className='position-change'>
                        { (_.has(this.props.autoLoanBankCountObj, row.value) && this.props.autoLoanBankCountObj[row.value]>0)? 
                          <div>
                          <Form.Checkbox
                            
                            
                            label= ''
                            name='bank'
                            value={row.value}
                            onChange={this.handleFilterChange}
                            checked={_.indexOf(this.props.filterValue.selectedBanks, row.value) >= 0}
                            disabled={_.has(this.props.autoLoanBankCountObj, row.value)?!this.props.autoLoanBankCountObj[row.value]>0:true}
                            className='display-inline-block'
                          />
                          
                          <span className='width-same-pos'>
                          <span className={_.indexOf(this.props.filterValue.selectedBanks, row.value) >= 0?"js-trigger-click  checked":"js-trigger-click  unchecked"}> {row.text}</span>
                          {_.has(this.props.autoLoanBankCountObj, row.value) && this.props.autoLoanBankCountObj[row.value]>0?
                            <span className='color-gray'> ({this.props.autoLoanBankCountObj[row.value]})</span>:
                            <span className='disabled field color-gray display-inline-block'> (0)</span>
                          }
                          </span>
                        </div>
                           :null 
                         }
                        </div>
                      
                      ))
                    }
                  </Form.Group>}
                </Form>
              )} />
            </Menu.Item>
          </Accordion>
        </Segment>
      </Segment.Group>
    );
  }
}

// HomeContainer.js

const mapStateToProps = (state, ownProps) => ({
  allAutoLoanDetails: state.allAutoLoanDetails,
  typeCountObj: state.autoLoanLoading.typeCountObj,
  autoLoanFeatureCountObj: state.autoLoanLoading.autoLoanFeatureCountObj,
  carTypesCountObj: state.autoLoanLoading.carTypesCountObj,
  autoLoanBankCountObj: state.autoLoanLoading.autoLoanBankCountObj,
  filterValue: state.autoLoanFilterAttribute,
  gotAutoLoanDataFromApi: state.gotAutoLoanDataFromApi,
  activeLanguage: state.activeLanguage,
});

const mapDispatchToProps = {
  storeAutoLoanDetails,
  storeAutoLoanFilterValue,
  storeCategoryAutoLoanCount,
};

const FilterContainer = withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(Filter));

export default FilterContainer;



// WEBPACK FOOTER //
// ./src/components/autoLoans/Filter.js